<template>
  <div class="custom-information-panel">
    <div class="custom-information">
      <p>{{ title }}</p>
    </div>
    <div class="custom-information-detail">
      <div>
        <p>Nuevo:</p>
        <p>
          <b>{{ news }}</b>
        </p>
      </div>
      <div>
        <p>Renovación:</p>
        <p>
          <b>{{ renovation }}</b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomInformation',
  props: {
    title: {
      type: String,
      default: '',
    },
    news: {
      type: String,
      default: '',
    },
    renovation: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.custom-information-panel {
  float: left;
  width: 80%;
  margin-left: 20px;
}
.custom-information {
  background-color: #e8e8e8;
  border-radius: 15px;
  color: #727272;
  text-align: center;
}

.custom-information-detail {
  float: left;
  width: 100%;
  padding: 0px 0px 0px 15px;
}

.custom-information-detail div {
  float: left;
  width: 50%;
}

.custom-information-detail div p {
  font-weight: normal;
  margin-bottom: 0px;
}
</style>
